<!-- SITE FOOTER-->
<footer class="footer d-none d-sm-none d-md-block d-lg-block d-xl-block">
    <div class="container container-xxl">

        <div class="row">
            <div class="col-9">
                <div class="row">
                    <ng-container *ngIf="footerItems">
                        <ng-container *ngFor="let item of footerItems;  let i=index">


                            <div *ngIf="i == 1" class="col-4" #myIdentifier style="margin-bottom: 60px;">
                                <h5>{{item?.title}}</h5>
                                <ul>
                                    <ng-container *ngFor="let link of item?.links">
                                        <li *ngIf="link?.visible"><a routerLink="/{{link?.link}}">{{link?.title}}</a>
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                            <div *ngIf="i != 1" class="col-4" style="margin-bottom: 60px;">
                                <h5>{{item?.title}}</h5>
                                <ul>
                                    <ng-container *ngFor="let link of item?.links">
                                        <li *ngIf="link?.visible"><a routerLink="/{{link?.link}}">{{link?.title}}</a>
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>

                        </ng-container>
                    </ng-container>
                </div>


            </div>
            <div class="col-3">
                <div class="contact" #contactEl [style.height.px]="myInnerHeight">
                    <h5>Contact us</h5>
                    <ul>
                        <li><a href="tel: {{ contact?.phone_number }}">Tel: {{ contact?.phone_number }}</a></li>
                        <li><a href="tel: {{ contact?.intl_phone_number }}">Intl: {{ contact?.intl_phone_number
                                }}</a>
                        </li>
                        <li><a href="mailto: {{ contact?.email_address }}">Email: {{ contact?.email_address }}</a>
                        </li>
                    </ul>
                    <div class="d-block mt-4">
                        <a href="{{ contact?.facebook }}" target="_blank"><img
                                src="assets/img/icn-social-facebook-outline.svg" class="d-inline-flex mr-3" /></a>
                        <a href="{{ contact?.instagram }}" target="_blank"><img
                                src="assets/img/icn-social-instagram-outline.svg" class="d-inline-flex mr-3" /></a>
                        <a href="{{ contact?.linkedin }}" target="_blank"><img
                                src="assets/img/icn-social-linkedin-outline.svg" class="d-inline-flex" /></a>
                    </div>
                </div>


                <h5 style="margin-top: 58px;">Curious to learn more?</h5>
                <p class="fg-dark-blue">Join our newsletter to receive updates on professional business
                    education
                </p>


                <div class="input-group mb-3" style="margin-top: 25px;">
                    <input type="text" class="form-control" placeholder="Your email address"
                        aria-label="Your email address" aria-describedby="form-subscribe" [(ngModel)]="email">
                    <div class="input-group-append">
                        <button class="btn btn-primary font-bold px-5" type="button"
                            (click)="subscribe()"><i class="material-symbols-outlined">east</i></button>
                    </div>

                    <div class="alert mt-4 mb-4 font-size-14 form-error" *ngIf="subscribeError">
                        {{ subscribeError }}
                    </div>
                    <div class="alert mt-4 mb-4 font-size-14 form-success" *ngIf="subscribedSuccess">
                        Subscribed successfully!
                    </div>
                </div>


            </div>
        </div>

    </div>
</footer>

<!-- MOBILE FOOTER -->
<footer class="footer d-block d-sm-block d-md-none" *ngIf="!router.url.includes('mobile-menu')">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h5>Curious to learn more?</h5>
                <p class="fg-dark-blue font-size-14">Join our newsletter to receive updates on professional business
                    education</p>

                <div class="form-group mb-3" style="margin-top: 25px;">
                    <input type="text" class="form-control font-size-14" placeholder="Your email address"
                        aria-label="Your email address" aria-describedby="form-subscribe" [(ngModel)]="emailMobile">
                    <button class="btn btn-primary btn-block mt-5 btn-lg font-weight-bold font-size-16" type="button"
                        (click)="subscribe()"><i class="material-symbols-outlined">east</i></button>

                    <div class="alert mt-4 mb-4 font-size-14 form-error" *ngIf="subscribeError">
                        {{ subscribeError }}
                    </div>
                    <div class="alert mt-4 mb-4 font-size-14 form-success" *ngIf="subscribedSuccess">
                        Subscribed successfully!
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 3rem;">
            <div class="col-12">
                <!-- Collapse -->

                <mat-accordion class="faqs" displayMode="flat" multi>
                    <mat-expansion-panel class="mat-elevation-z0" hideToggle
                        *ngFor="let item of footerItems;  let i=index">
                        <mat-expansion-panel-header collapsedHeight="60px" expandedHeight="60px">
                            <mat-panel-title>
                                <div class="container-fluid p-0">
                                    <div class="row">
                                        <div class="col d-flex align-items-center">
                                            <h5 class="mb-0">{{item?.title}}</h5>
                                        </div>
                                        <div class="col-auto d-flex align-items-center">
                                            <img loading="lazy" src="assets/img/icn-open-down-medium.svg"
                                                class="accordion-open-indicator" />
                                            <img loading="lazy" src="assets/img/icn-open-up-medium.svg"
                                                class="accordion-close-indicator" />
                                        </div>
                                    </div>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul>
                            <ng-container *ngFor="let link of item?.links">
                                <li *ngIf="link?.visible"><a routerLink="/{{link?.link}}">{{link?.title}}</a></li>
                            </ng-container>
                        </ul>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
        <div class="row" style="margin-top: 3rem;">
            <div class="col-12">
                <h5>Contact us</h5>
                <ul>
                    <li class="font-size-14">
                        <a href="tel: {{ contact?.phone_number }}">
                            Tel: {{ contact?.phone_number }}
                        </a>
                    </li>
                    <li class="font-size-14">
                        <a href="tel: {{ contact?.intl_phone_number }}">
                            Intl: {{ contact?.intl_phone_number }}
                        </a>
                    </li>
                    <li class="font-size-14">
                        <a href="mailto: {{ contact?.email_address }}">
                            Email: {{ contact?.email_address }}
                        </a>
                    </li>
                </ul>

                <div class="d-block mt-4">
                    <a href="{{ contact?.facebook }}" target="_blank"><img
                            src="assets/img/icn-social-facebook-outline.svg" class="d-inline-flex mr-3" /></a>
                    <a href="{{ contact?.instagram }}" target="_blank"><img
                            src="assets/img/icn-social-instagram-outline.svg" class="d-inline-flex mr-3" /></a>
                    <a href="{{ contact?.linkedin }}" target="_blank"><img
                            src="assets/img/icn-social-linkedin-outline.svg" class="d-inline-flex" /></a>
                </div>
            </div>
        </div>
    </div>
</footer>

<section class="footer-final" *ngIf="!router.url.includes('mobile-menu')">
    <div class="container container-xxl">
        <div class="row">
            <div
                class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-6 d-flex align-items-center justify-content-center justify-content-lg-start py-3 per100">
                <!--<img loading="lazy" class="d-inline-flex mr-2" src="assets/img/icn-secure.svg" />-->
                <span class="material-symbols-outlined text-white font-size-30 mr-1">lock</span>
                <p class="font-size-16 mb-0 d-inline-flex">100% Secure</p>
                <img loading="lazy" class="d-inline-flex ml-3" src="assets/img/component-payment-icons.svg" />
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-6 py-3">
                <p class="mb-0 font-size-16 text-center text-md-center text-lg-right text-xl-right">&copy; {{
                    copyrightDate }} International Business Training College | Level 2 B-BBEE Supplier</p>
            </div>
        </div>
    </div>
</section>